var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deafult-view-wrapper"},[_c('DefaultMenuView',{attrs:{"path":"pic_call","text":"云客服呼叫中心"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }